import { PreferredLeaseLength, PreferredLeaseLength_values } from '@zg-rentals/ts-capps-client';

export const PREFERRED_LEASE_LENGTH_LABELS: Record<PreferredLeaseLength, string> = {
  [PreferredLeaseLength.MONTH_TO_MONTH]: 'Month-to-month',
  [PreferredLeaseLength.SIX_MONTHS]: '6 months',
  [PreferredLeaseLength.TWELVE_MONTHS]: '12 months',
  [PreferredLeaseLength.TWENTY_FOUR_MONTHS]: '24 months',
};

export function isPreferredLeaseLength(value: unknown): value is PreferredLeaseLength {
  return (PreferredLeaseLength_values as ReadonlyArray<unknown>).includes(value);
}

export function getPreferredLeaseLengthsDisplay(preferredLeaseLengths: ReadonlyArray<string> | null | undefined) {
  return PreferredLeaseLength_values.filter((value) => preferredLeaseLengths?.includes(value))
    .map((value) => PREFERRED_LEASE_LENGTH_LABELS[value])
    .join(', ');
}
